import Signal from "./Signal";

export default function ResumeScoreCard({
  score,
  atsParsing,
  jobMatch,
  recruiterImpact
}) {

  return (
    <div className="bg-gradient-to-br from-indigo-600 to-blue-500 text-white rounded-2xl p-8 shadow-xl flex justify-between items-center">

      <div>
        <h2 className="text-2xl font-bold mb-2">
          Resume Score
        </h2>

        <p className="text-white/90">
          Improve your resume to increase interview chances 🚀
        </p>

        <div className="flex gap-3 mt-4 flex-wrap">
          <Signal label="ATS" value={atsParsing} type="green" />
          <Signal label="Match" value={jobMatch} type="yellow" />
          <Signal label="Impact" value={recruiterImpact} type="red" />
        </div>
      </div>

      <div className="text-5xl font-bold">
        {score}
      </div>

    </div>
  );
}